/** Resolve the active canvas association, never an unrelated portfolio selection. */
export function simulationSiteId(state: {
  activeTabId?: string | null;
  tabs?: readonly { id: string; site?: { id?: string } | null }[];
  site?: { id?: string } | null;
}): string | null {
  const tab = state.tabs?.find(candidate => candidate.id === state.activeTabId);
  const site = tab && tab.site !== undefined ? tab.site : state.site;
  return typeof site?.id === 'string' && site.id.trim() ? site.id : null;
}
